import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Card, CardBody, CardHeader, Container } from "reactstrap";
import BreadCrumb from "components/common/BreadCrumb";
import { getDocumentTitle } from "utils/helpers";
import { useAccess } from "features/Authentication/hooks/useAccess";
import { Permissions } from "features/RolesAndPermissions/constants/permission.constants";
import { PaymentExpectationsTable } from "./PaymentExpectationsTable";
import PaymentExpectationSummaryWidgets from "./PaymentExpectationSummaryWidgets";

const PaymentExpectationList = () => {
  document.title = getDocumentTitle("Collections");
  const { can } = useAccess();
  const [refreshSignal, setRefreshSignal] = useState(0);
  const handleTableMutation = useCallback(() => setRefreshSignal((s) => s + 1), []);
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Collections" pageTitle="Finance" />
        <Alert color="info" className="border-0 mb-3" fade={false}>
          <div className="d-flex gap-2 align-items-start">
            <i className="ri-information-line fs-18 flex-shrink-0 mt-1" />
            <div>
              <strong>What are Collections?</strong> Collections track expected
              payments from clients — linked to invoices, AMC advances or AMCs. Use
              this page to log due dates, record receipts as payments arrive,
              and monitor outstanding balances. Each collection moves through{" "}
              <strong>Pending → Partially Received → Received</strong> (or{" "}
              <strong>Cancelled</strong>) as payments are recorded.
            </div>
          </div>
        </Alert>
        <PaymentExpectationSummaryWidgets refreshSignal={refreshSignal} />
        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">Collections</h5>
            {can(Permissions.PAYMENT_EXPECTATION.CREATE) ? (
              <Link
                to="/finance/payment-expectations/create"
                className="btn btn-primary"
              >
                <i className="ri-add-line align-bottom me-1" />
                New collection
              </Link>
            ) : null}
          </CardHeader>
          <CardBody>
            <PaymentExpectationsTable onMutation={handleTableMutation} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PaymentExpectationList;
